<template>
  <div class="ei-person-detail">
    <div style="margin-top: 75px"></div>
    <ei-long-figure-scroll-for-person
      :works-list="typeof person.worksList==='undefined'?[]:person.worksList">
    </ei-long-figure-scroll-for-person>
    <div class="title-wrap-top">
      <div v-if="person.coverArea==='画家'">
      <div v-if="person.personName.indexOf('·')===1">
      <img  :src="characterPattern"  alt="">
      <span>{{person.personName}} · 绘画作品集</span>
      <img  :src="characterPattern" alt="">
      </div>
        <div v-else>
          <img  :src="characterPattern" alt="">
          <span>{{person.dynasty}} · {{person.personName}} · 绘画作品集</span>
          <img  :src="characterPattern" alt="">
        </div>
      </div>
      <div v-if="person.coverArea==='书法家'">
        <div v-if="person.personName.indexOf('·')===1">
        <img  :src="characterPattern" alt="">
        <span>{{person.personName}} · 书法作品集</span>
        <img  :src="characterPattern" alt="">
        </div>
        <div v-else>
          <img  :src="characterPattern" alt="">
          <span>{{person.dynasty}} · {{person.personName}} · 书法作品集</span>
          <img :src="characterPattern" alt="">
        </div>
      </div>
  </div>

    <div class="person-detail">
      <div class="calligrapher-info">
        <div class="calligrapher-pic">
          <img  class="lazyLoading" :data-src="person.url"/>
<!--          <span>{{ person.personName }}</span>-->
        </div>
        <div class="calligrapher-desc" style="font-size: 24px;white-space: pre-wrap;overflow:auto;">
          <span>{{ person.description + person.worksDescription }}</span>
        </div>
      </div>
      <div class="calligrapher-works">
        <div class="works-list" style="position: relative">
          <div class="title-wrap" v-if="person.coverArea==='书法家' && person.personName">
            <img  :src="characterPattern" alt="">
            <span v-if="person.personName.indexOf('·')===1">{{person.personName+ ' · 凌烟阁 · 双勾书法 · 作品集' }}</span>
            <span v-else>{{person.dynasty+' · '+person.personName+ ' · 凌烟阁 · 双勾书法 · 作品集' }}</span>
            <img  :src="characterPattern" alt="">
          </div>
          <div class="title-wrap" v-else-if="person.personName">
            <img  :src="characterPattern" alt="">
            <span v-if="person.personName.indexOf('·')===1">{{person.personName+ ' · 凌烟阁 · 双勾绘画 · 作品集' }}</span>
            <span v-else>{{person.dynasty+' · '+person.personName+ ' · 凌烟阁 · 双勾绘画 · 作品集' }}</span>
            <img :src="characterPattern" alt="">
          </div>
          <div class="spirit" style="position: absolute;margin-top: 28px;right: 250px;">
            <img :src="serialNumberPattern1"  style="width: 35px"/>
          </div>
       <div class="spirit" style="position: absolute;margin-top:28px;right: 50px">
            <span>凌烟阁作品序列号</span>
          </div>
          <div class="list" style="margin-top: 80px;margin-left: 80px">
            <ul>
              <li class="item" v-for="(item,index) in worksPage.list" :key="index">
                <a>
                  <img :src="mainIdentification"  width="22.5px" style="vertical-align: middle"/>
                  <div class="title">
                                    <span :class="{'fontWeight-anim':true,'active':item.activeFontWeight}">
                                        <span @click="toWorksDetail(item.rowGuid)">{{ item.worksName }}  <span
                                          style="margin-left: 25px">当代 丶凌烟阁双勾 丶独家版权</span>
                                        <span style="margin-left: 25px">{{ item.wordCount }}字</span></span>

                                    </span>
                  </div>
                  <div :class="{'fen fontColor-anim':true,'active':item.activeFontWeight}">
                    <img :src="serialNumberPattern2"  width="28px" style="vertical-align: middle;margin-left: -148px"/>
                    <span style="margin-left: 25px;font-size: 22px;margin-top: -5px;position: absolute;color: gold">{{ item.worksSerialNumber }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="works-statistic">
          <div class="item">
            <span class="key">关联法帖</span>
            <span class="value">{{ worksPage.total }}</span>
          </div>
          <div class="item">
            <span class="key">双勾总字数</span>
            <span class="value">{{ worksPage.wordCountTotal }}</span>
          </div>
        </div>
      </div>
      <ei-works-page :works-page="worksPage" @pageNumChange="pageNumChange"></ei-works-page>
    </div>
    <ei-footer></ei-footer>
  </div>

</template>

<script>
export default {
  name: 'EiPersonDetail',
  props: {
    person: {
      type: Object,
      required: true
    },
    worksPage: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      imgIndex: 0,
      titleButterflyImg: '/upload/homeBlock/1/titleButterflyImg.png',
      articleListImg: '/upload/homeBlock/1/articleListImg.png',
      characterPattern:  require("../eiuov-ui/_ei-flower/1.png"),
      serialNumberPattern1: require("../eiuov-ui/_ei-flower/作品序列号花纹1.png"),
      mainIdentification: require("../eiuov-ui/_ei-flower/AEIUOV主标识(外加图形)白.png"),
      serialNumberPattern2: require("../eiuov-ui/_ei-flower/作品序列号花纹2.png"),
    }
  },
  created() {
  },
  watch: {},
  methods: {
    pageNumChange(pageNumNew) {
      this.$emit('pageNumChange', pageNumNew)
    },
    toWorkDetail(rowGuid) {
      this.$cookies.set('works_guid', rowGuid)
      this.$router.push({
        path: '/WorksDetail',
        query: {guid: rowGuid}
      })
    },
    toWorksDetail(rowGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: {guid: rowGuid}
      })

    },
/*    isInSight(el) {
      const bound = el.getBoundingClientRect();
      const clientHeight = window.innerHeight;
      return bound.top <= clientHeight + 100;
    },
    checkImgs() {
      const imgs = document.querySelectorAll('.lazyLoading');
      for (let i = this.imgIndex; i < imgs.length; i++) {
        if (this.isInSight(imgs[i])) {
          this.loadImg(imgs[i]);
          this.imgIndex = i;
        }
      }
    },
    //加载图片
    loadImg(el) {
      if (!el.src) {
        const source = el.dataset.src;
        el.src = source;
      }
    },
    //函数节流
    throttle(fn, mustRun = 500) {
      let previous = null;
      return
      const now = new Date();
      const context = this;
      const args = arguments;
      if (!previous) {
        previous = now;
        fn.apply(context, args);
      }
      const remaining = now - previous;
      if (mustRun && remaining >= mustRun) {
        fn.apply(context, args);
        previous = now;
      }
    },
  },
  mounted() {
    window.onload = this.checkImgs();
    //滚动时调用
    window.onscroll = this.throttle(this.checkImgs());
  },*/
}
}
</script>
<style>
::-webkit-scrollbar{
  width: 0;
}
</style>
<style scoped lang="scss">
.ei-person-detail{

  width: 100%;
  overflow: hidden;

.scroll-img {
  position: relative;
  width: 100%;
  height: 480px;
}

.title-wrap {
  position: absolute;
  text-align: left;
  margin-top: 20px;
  left: 80px;
  font-size: 30px;
  color: #fff;

  span {
    vertical-align: middle;
  }

  img {
    width: 60px;
    vertical-align: middle;

    &:nth-child(1) {
      margin-right: 10px;
    }

    &:nth-child(3) {
      margin-left: 10px;
      transform: scaleX(-1);
    }
  }
}

.person-detail {
  position: relative;
  width: 1440px;
  margin-left: 232px;
  margin-top: 300px;
}

.calligrapher-info {
  margin-top: -190px;
  width: 1440px;
  display: flex;
  justify-content: space-between;
  height: 480px;

  .calligrapher-pic {
    display: inline-block;
    width: 400px;
    background-color: #a37d4c;


    span {
      display: block;
      color: red;
      font-size: 30px;
      margin-left: 160px;
      margin-top: -40px;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .calligrapher-desc {
    width: 1440 - 400 - 30px;
    display: inline-block;
    background-color: #7f1f21;

    span {
      color: #fff;
      font-size: 26px;
      display: block;
      width: 90%;
      margin: 50px auto;
      letter-spacing: 2px;
      line-height: 50px;
    }
  }
}

.calligrapher-works {
  width: 1440px;
  display: flex;
  justify-content: space-between;
  height: 400px;
  margin-top: 30px;

  .works-list {
    width: 1440px - 300;
    background-color: #304c64;


    .spirit {
      color: #fff;
      font-size: 24px;
      text-indent: 52px;
      text-align: right;
    }

    .list {
      width: 90%;
      height: 300px;
      overflow: hidden;
      position: relative;
      margin-top: 10px;
      padding-left: 0;
      margin-left: 30px;

      .item {
        margin-bottom: 12px;

        .num {
          display: inline-block;
          width: 20px;
          height: 27px;
          text-align: right;
          vertical-align: middle;
          line-height: 27px;
          font-style: italic;
          font-size: 18px;
        }

        .title {
          margin-left: 15px;
          height: 27px;
          display: inline-block;
          vertical-align: middle;
          line-height: 27px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 20px;
        }

        .fen {
          width: 100px;
          float: right;
          font-size: 17px;
          height: 26px;
          font-style: italic;

          .fenZi {
            font-size: 22px;
            margin-right: 5px;
          }

          .fenMu:before {
            content: "/";
            margin-right: 5px;
          }
        }
      }
    }
  }

  .works-statistic {
    width: 300px;
    background-color: #243a4f;
    padding-top: 40px;

    .item {
      span {
        display: block;
        margin-top: 20px;
        text-align: center;
        color: #fff;
      }

      .key {
        font-size: 30px;
      }

      .value {
        font-size: 36px;
        font-family: Impact, Arial, serif;
      }
    }
  }
}

$width1440: 1440px;
.works-item-list {
  width: $width1440;
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto;
  justify-content: flex-start;

  .works-item:not(:nth-child(4n)) {
    margin-right: 80px;
  }
}

.clear-authenticate {
  width: 1440px;
  display: flex;
  justify-content: space-between;
  height: 350px;
  margin-top: 30px;

  .summary {
    width: 300px;
    background-color: #243a4f;
    padding-top: 40px;
    color: #fff;
    writing-mode: vertical-lr;

    .title1 {
      display: block;
      margin-left: 50px;
      font-size: 35px;
      letter-spacing: 10px;
    }

    .title2 {
      display: block;
      margin-top: 50px;
      margin-left: 35px;
      font-size: 50px;
      letter-spacing: 25px;
    }
  }

  .detailed-list {
    width: 1440px - 300;
    background-color: #304c64;

    .spirit {
      margin-top: 20px;
      color: #fff;
      font-size: 40px;
      text-indent: 52px;
    }

    .list {
      width: 95%;
      height: 230px;
      overflow: hidden;
      position: relative;
      margin-top: 20px;
      padding-left: 0;
      margin-left: 30px;

      .item {
        margin-bottom: 12px;

        .num {
          display: inline-block;
          width: 20px;
          height: 27px;
          text-align: right;
          vertical-align: middle;
          line-height: 27px;
          font-style: italic;
          font-size: 18px;
        }

        .title {
          margin-left: 15px;
          height: 27px;
          display: inline-block;
          vertical-align: middle;
          line-height: 27px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 20px;
        }

        .fen {
          width: 60px;
          float: right;
          font-size: 17px;
          height: 26px;
          font-style: italic;

          .fenZi {
            font-size: 22px;
            margin-right: 5px;
          }

          .fenMu:before {
            content: "/";
            margin-right: 5px;
          }
        }
      }
    }
  }
}
}

$width1440: 1440px;
.title-wrap-top {
  position: absolute;
  margin-left: 162px;
  margin-top: 10px;
  width: $width1440;
  height: 85px;
  line-height: 75px;
  left: 70px;
  font-size: 30px;
  color: #fff;
  background-color: #9a7a50;
  text-align: center;


  span {
    vertical-align: middle;
  }

  img {
    vertical-align: middle;
    width: 80px;

    &:nth-child(1) {
      margin-right:30px;
    }

    &:nth-child(3) {
      margin-left: 30px;
      transform: scaleX(-1);
    }
  }
}
* img,span,a,div{
  user-select: none;
  -webkit-user-drag:none;
}
</style>
